module.exports = __webpack_public_path__ + "img/40_46.b5d5579a.png";